import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { HYDRATE } from 'next-redux-wrapper'
import { PaymentMethodsState } from './types'
import IPaymentMethod from '@/types/payment-method.interface'

const initialState: PaymentMethodsState = {
  list: [],
}

const paymentMethodsSlice = createSlice({
  name: 'payment-methods',
  initialState,
  reducers: {
    setPaymentMethods: (state, action: PayloadAction<IPaymentMethod[]>) => {
      state.list = action.payload
    },
  },
  extraReducers: (builder) => {
    builder.addCase(HYDRATE, (state, action) => {
      return {
        ...state,
        // @ts-ignore
        ...action.payload.paymentMethods,
      }
    })
  },
})

export const { setPaymentMethods } = paymentMethodsSlice.actions

export default paymentMethodsSlice
